<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать спрос</strong>
                </CCardHeader>
                <CCardBody>
                    <DemandUpsertForm @success="$router.push(`/demands`)" />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import DemandUpsertForm from '@/components/demands/DemandUpsertForm';

    export default {
        name: 'DemandCreate',

        components: {
            DemandUpsertForm,
        },
    };
</script>
